module.exports = __webpack_public_path__ + "assets/btn-open-en-83459094.png";